import type { FaireProductEntity } from "../../entity_types/product";

export const p_hf2b72dyx9: FaireProductEntity = {
  token: "p_hf2b72dyx9",
  type: "product",
  name: "Smudge Spray - Soul Sticks Palo Santo & Sandalwood (3.5 oz)",
  brandToken: "b_89kf2nlsjr",
  brandName: "Designs by Deekay Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/77d7be8782a53bc551ad66c6b30171de7d0e39c8af4d2fc2f1f2648112bac20b.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.58,
  description:
    "Smudge Spray - Soul Sticks Palo Santo & Sandalwood (3.5 oz)\n \n PRODUCT SPECS\n • Size: 3.5 oz.\n • Format: Smudge spray\n • Ingredients: Purified water, palo santo wood, quartz crystals, and essential oils\n • Packaging: Retail box included\n • Scent/Profile: Palo Santo & Sandalwood\n \n RETAIL PERFORMANCE\n • Smoke-free format broadens cleansing assortments for modern retail settings\n • Palo Santo and sandalwood pairing is a strong fit for spiritual and wellness stores\n • Retail-ready packaging supports gifting and neat shelf presentation\n • Easy to merchandise near candles, sprays, incense, and altar goods\n • Compact bottle works well for counter and impulse placement",
  tags: [],
  msrpDollars: 13.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:07.161Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
